import React from 'react';
import { Input } from '../ui/Input';
import { ChipGroup } from './ChipGroup';
import { SEATS, START_DATES, TIMEZONES, WORK_SETUPS } from '../../data/careers';
import type { StepProps } from '../../types/careers';
export function StepSeat({
  form,
  errors,
  onChange
}: StepProps) {
  const toggleOtherSeat = (seat: string) => {
    const next = form.otherSeats.includes(seat) ? form.otherSeats.filter(s => s !== seat) : [...form.otherSeats, seat];
    onChange('otherSeats', next);
  };
  return <div className="space-y-6" data-id="element-66" data-mp="16wf4ttko967w">
      <Input label="Main seat you're applying for" name="primarySeat" as="select" value={form.primarySeat} error={errors.primarySeat} onChange={e => onChange('primarySeat', e.target.value)} options={SEATS.map(seat => ({
      value: seat,
      label: seat
    }))} data-id="element-67" data-mp="16woyps8u7xiv" />

      <ChipGroup label="Other seats you could fill" hint="optional" options={SEATS.filter(seat => seat !== form.primarySeat)} selected={form.otherSeats} onToggle={toggleOtherSeat} data-id="element-68" data-mp="2mabcfqvifqp6" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-69" data-mp="1eam1ay0cwfh5">
        <Input label="Where you're based" name="location" placeholder="Miami, FL" value={form.location} error={errors.location} onChange={e => onChange('location', e.target.value)} data-id="element-70" data-mp="1e89nmx1msr9w" />
        <Input label="Your time zone" name="timezone" as="select" value={form.timezone} error={errors.timezone} onChange={e => onChange('timezone', e.target.value)} options={TIMEZONES} data-id="element-71" data-mp="10be0k0ojozau" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-72" data-mp="158wd011rtwnl">
        <Input label="How do you want to work?" name="workSetup" as="select" value={form.workSetup} error={errors.workSetup} onChange={e => onChange('workSetup', e.target.value)} options={WORK_SETUPS} data-id="element-73" data-mp="15bsbbqhj6nck" />
        <Input label="Earliest you can start" name="earliestStart" as="select" value={form.earliestStart} error={errors.earliestStart} onChange={e => onChange('earliestStart', e.target.value)} options={START_DATES} data-id="element-74" data-mp="1ddfbt1d39ohg" />
      </div>
    </div>;
}